module.exports = __webpack_public_path__ + "img/logo_login.fb1018ba.png";